<template>
    <div class="header__logo">
        <router-link :to="logoLink">
            <img :src="logo" alt="Apcoa Portal Logo" />
        </router-link>
    </div>
</template>

<script setup>
import { computed } from 'vue'
import { useUserStore } from '@/store/userStore'
import useDomainConfig from '@/composables/useDomainConfig'

const userStore = useUserStore()
const { logo } = useDomainConfig()

const isUserAuthenticated = computed(() => userStore.isAuth)
const logoLink = computed(() => isUserAuthenticated.value ? '/dashboard' : '/')
</script>

<style lang="scss" scoped>
.header__logo img {
    width: rem(220px);
    height: auto;
}
</style>
